<template>
  <div class="content-builder">
    <div class="mt-4 mb-4">
      <button class="btn btn-primary" type="button" v-on:click="addItem">Add Item</button>
    </div>
    <ul v-if="content.items && content.items.length > 0" class="list-group">
      <li v-for="(item, index) in content.items" :key="index" class="list-group-item">
        <div class="mb-4">
          <div class="w-50">
            <label>Base Image</label>
            <img v-if="item.baseImg" :src="item.baseImg" alt="" class="img-thumbnail mb-2">
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <a :data-input="'image-base-' + index" class="btn btn-primary text-white" data-lfm="image">
                  <i class="fa fa-image"></i>
                </a>
              </div>
              <input :id="'image-base-' + index" v-model="item.baseImg" class="form-control" type="text">
            </div>
          </div>
          <div class="w-50">
            <label>Hover Image</label>
            <img v-if="item.hoverImg" :src="item.hoverImg" alt="" class="img-thumbnail mb-2">
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <a :data-input="'image-hover-' + index" class="btn btn-primary text-white" data-lfm="image">
                  <i class="fa fa-image"></i>
                </a>
              </div>
              <input :id="'image-hover-' + index" v-model="item.hoverImg" class="form-control" type="text">
            </div>
          </div>
          <div class="mb-4">
            <textarea :id="'modal-content-' + index" v-model="item.modalContent" class="form-control"
                      placeholder="Modal Content"></textarea>
          </div>
          <div class="input-group mb-0">
            <input v-model="item.label" class="form-control" placeholder="Item Label" type="text">
            <button class="btn btn-danger" type="button" @click="content.items.splice(index, 1)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import _ from 'lodash'
import layoutMixin from '../../mixins/layout'
import {v4 as uuid4} from 'uuid'
import {EDITOR_CONFIG_BUTTONS_FULL, EDITOR_CONFIG_LITE} from '../../../common/constants'
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
  components: {
    QuillEditor
  },
  mixins: [layoutMixin],
  data() {
    return {
      content: _.cloneDeep(this.source),
      toolbarOpts: EDITOR_CONFIG_BUTTONS_FULL,
      editorOpts: EDITOR_CONFIG_LITE
    }
  },
  methods: {
    getValue() {
      return this.content
    },
    addItem() {
      if (!this.content.items) {
        this.content.items = []
      }
      this.content.items.push({
        label: '',
        baseImg: '',
        hoverImg: '',
        modalContent: '',
        id: uuid4()
      })
    }
  }
}
</script>
